import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { ChevronDown, UserRound } from 'lucide-react';
import { Button } from '../ui/button';
import { ComercialLink } from '../comercial360/com360Shared';
import { API_URL, PendBadge, Countdown, ACTION_LABEL, OUTCOMES, fmtDT } from './pendShared';

const OPEN = ['enviado', 'lido', 'em_atraso', 'pendente_resolucao'];

export const PendCard = ({ p, mine, manager, onAction, onChanged }) => {
  const [showHist, setShowHist] = useState(false);
  const cancel = async () => {
    if (!window.confirm('Cancelar esta pendência?')) return;
    try { await axios.post(`${API_URL}/pendencias/${p.id}/cancelar`); toast.success('Cancelada'); window.dispatchEvent(new Event('pendencias-changed')); onChanged(); } catch (e) { toast.error((typeof e.response?.data?.detail === 'string' && e.response.data.detail) || 'Erro'); }
  };
  const open = OPEN.includes(p.status);
  return (
    <div className={`rounded-xl border bg-white p-4 space-y-2 ${p.status === 'em_atraso' || p.atrasado ? 'border-rose-300' : 'border-slate-200'}`} data-testid={`pend-card-${p.id}`}>
      <div className="flex flex-wrap items-center gap-2 justify-between">
        <div className="flex items-center gap-2 min-w-0">
          <span className="font-semibold text-slate-800 truncate">{p.client_name}</span>
          {p.nif && <Link to={`/clientes/360?nif=${encodeURIComponent(p.nif)}`} className="text-[#2D3E6F] hover:text-[#4DD4E8]" title="Página do Cliente"><UserRound className="w-4 h-4" /></Link>}
          <PendBadge status={p.status} testId={`pend-status-${p.id}`} />
          {p.atrasado && <span className="text-[10px] font-bold px-2 py-0.5 rounded-full bg-rose-100 text-rose-700">Atrasou</span>}
        </div>
        {['enviado', 'lido'].includes(p.status) && <Countdown deadline={p.deadline_at} testId={`pend-countdown-${p.id}`} />}
      </div>
      <div className="text-sm text-slate-600">{p.situacao}</div>
      <div className="text-xs text-slate-500">
        {manager && <>Para <ComercialLink id={p.recipient_id} name={p.recipient_name} className="font-bold" /> · </>}De {p.sender_name} · {fmtDT(p.created_at)}{p.read_at && <> · lido {fmtDT(p.read_at)}</>}
        {p.outcome && <> · <b className="text-emerald-700">{OUTCOMES[p.outcome]}</b></>}
      </div>
      {p.justificacao && <div className="text-xs text-rose-700 bg-rose-50 rounded-lg p-2"><b>Justificação:</b> {p.justificacao}</div>}
      <div className="flex flex-wrap items-center gap-2 pt-1">
        {mine && open && p.status !== 'em_atraso' && (
          <>
            <Button size="sm" variant="outline" onClick={() => onAction(p, 'seguimento')} data-testid={`pend-followup-${p.id}`}>Dar seguimento</Button>
            <Button size="sm" className="bg-emerald-600 hover:bg-emerald-700" onClick={() => onAction(p, 'concluir')} data-testid={`pend-close-${p.id}`}>Concluir</Button>
          </>
        )}
        {mine && p.status === 'em_atraso' && <Button size="sm" className="bg-rose-600 hover:bg-rose-700" onClick={() => onAction(p, 'justificar')} data-testid={`pend-justify-${p.id}`}>Justificar</Button>}
        {manager && open && <Button size="sm" variant="ghost" className="text-slate-500" onClick={cancel} data-testid={`pend-cancel-${p.id}`}>Cancelar</Button>}
        <button onClick={() => setShowHist((s) => !s)} className="ml-auto text-xs text-slate-500 inline-flex items-center gap-1" data-testid={`pend-history-toggle-${p.id}`}>
          Histórico ({p.historico?.length || 0}) <ChevronDown className={`w-3 h-3 transition-transform ${showHist ? 'rotate-180' : ''}`} />
        </button>
      </div>
      {showHist && (
        <ol className="border-l border-slate-200 pl-3 space-y-1 text-xs" data-testid={`pend-history-${p.id}`}>
          {(p.historico || []).map((h, i) => (
            <li key={i}><b>{ACTION_LABEL[h.action] || h.action}</b> · {h.by} · {fmtDT(h.at)}{h.note ? <span className="block text-slate-600">{h.note}</span> : null}</li>
          ))}
        </ol>
      )}
    </div>
  );
};
